<script setup lang="ts">
import Logo from '../Logo.vue';
</script>

<template>
	<div class="entry-card">
		<div class="entry-card__logo">
			<Logo />
		</div>
		<div class="entry-card__header" v-if="$slots.header">
			<slot name="header" />
		</div>
		<div class="entry-card__body">
			<slot />
		</div>
	</div>
</template>

<style scoped lang="scss">
@layer hm-components
{
	.entry-card
	{
		@include flex;
		flex-direction:column;
		width:100%;
		padding-block:var(--spacing-xl);

		@include responsive(md)
		{
			max-width:var(--container-xs);
			border-radius:var(--radius-4xl);
			background-color:var(--bg-primary);
			box-shadow:var(--shadow-2xl);
			padding:var(--spacing-4xl);
		}

		&__logo
		{
			padding-block-end:var(--spacing-4xl);
		}
		&__header
		{
			@include flex;
			flex-direction:column;
		}
		&__body
		{
			@include flex(null, null, var(--spacing-lg));
			flex-direction:column;
		}
	}
}
</style>
